import { requiredRoles } from '@/shared/utils/require-roles'
import { UserRole } from '@depanneo/types'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

const newInterventionSearchSchema = z.object({
  prefilledEquipmentId: z.string().optional(),
  prefilledSiteId: z.string().optional(),
})

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/interventions/new'
)({
  validateSearch: (search) => newInterventionSearchSchema.parse(search),
  beforeLoad() {
    requiredRoles([UserRole.ADMIN, UserRole.FACILITY_MANAGER, UserRole.VIEWER])
  },
})
